import { render, staticRenderFns } from "./booking-event-calendar-public-page.vue?vue&type=template&id=5c1357cf&"
import script from "./booking-event-calendar-public-page.ts?vue&type=script&lang=ts&"
export * from "./booking-event-calendar-public-page.ts?vue&type=script&lang=ts&"
import style0 from "./booking-event-calendar-public-page.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports